module.exports = __webpack_public_path__ + "c1182f81e04636d72e82c075e70d7800.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/logo.png
 ** module id = 615
 ** module chunks = 0
 **/